import { render, staticRenderFns } from "./FrzChamberPalletInTunnel.vue?vue&type=template&id=4cf273ae"
import script from "./FrzChamberPalletInTunnel.vue?vue&type=script&lang=js"
export * from "./FrzChamberPalletInTunnel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports